import styled, { css } from 'styled-components'

import { ReactComponent as Couponfile } from 'assets/icons/coupon.svg'
import { ReactComponent as SearchFile } from 'assets/icons/search.svg'

import { ReactComponent as EditFile } from 'assets/icons/edit.svg'
import { ReactComponent as TrashFile } from 'assets/icons/trash-alt.svg'

export const EditIcon = styled(EditFile)`
  ${({ theme }) => css`
    height: 24px;
    cursor: pointer;
    fill: ${theme.color.neutral.nth3};
    margin-right: ${theme.spacing.stack.xxxs};
    :hover {
      fill: ${theme.color.brand.primary.nth1};
    }

    @media (max-width: 767px) {
      height: 16px;
      width: 16px;
      margin-right: ${theme.spacing.stack.small};
    }
  `}
`
export const TrashIcon = styled(TrashFile)`
  ${({ theme }) => css`
    cursor: pointer;
    fill: ${theme.color.neutral.nth3};
    :hover {
      fill: ${theme.color.alert.error.nth1};
    }
    @media (max-width: 767px) {
      height: 16px;
      width: 16px;
    }
  `}
`

export const Container = styled.div``

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  > div:first-child {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.font.size.md};
    font-weight: ${theme.font.weight.bold};
  `}
`

export const CouponIcon = styled(Couponfile)`
  ${({ theme }) => css`
    width: 48px;
    height: 48px;
  `}
`

export const SearchIcon = styled(SearchFile)`
  position: relative;
  fill: #39383a;
  left: 1.5%;
  top: 48px;
`

export const Searchnput = styled.input`
  ${({ theme }) => css`
    background: ${theme.color.neutral.nth4};
    padding: ${theme.spacing.stack.xxxs} ${theme.spacing.stack.xxxs}
      ${theme.spacing.stack.xxxs} 72px;
    width: 100%;
    font-size: ${theme.font.size.sm};
    border-radius: ${theme.border.radius.medium};
    outline: 0;
    border: 0;
    margin-bottom: ${theme.spacing.stack.xxs};

    &::placeholder {
      font-size: ${theme.font.size.sm};
    }
  `}
`

export const TableHeader = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 1fr;
    background: ${theme.color.base.nth4};
    padding: ${theme.spacing.stack.xxxs};
    border-radius: 6px;
    margin-bottom: ${theme.spacing.stack.small};
    @media (max-width: 767px) {
      margin-top: ${theme.spacing.stack.xxxs};
      grid-template-columns: 1fr 2fr 1fr 1fr;
      padding: ${theme.spacing.stack.xxxs} ${theme.spacing.stack.small};
      gap: ${theme.spacing.inline.nano};
    }

    @media (min-width: 768px) and (max-width: 1170px) {
      margin-top: ${theme.spacing.stack.xxxs};
    }
  `}
`

export const TableTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.color.base.nth2};
    @media (min-width: 1171px) {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      text-align: left;
    }
    @media (min-width: 768px) and (max-width: 1170px) {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      text-align: left;
    }

    @media (max-width: 767px) {
      font-size: 12px;
      font-weight: 400;
      line-height: 12px;
    }
  `}
`

export const TableData = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 1fr;
    background: ${theme.color.neutral.nth4};
    box-shadow: 0 4px 11px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    padding: ${theme.spacing.stack.xxs} ${theme.spacing.stack.xxxs};
    margin-bottom: ${theme.spacing.stack.xxxs};
    align-items: center;
    div:last-of-type {
      margin-left: auto;
    }
    @media (max-width: 767px) {
      .data-info {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        text-align: left;
      }
      padding: ${theme.spacing.stack.xxxs} ${theme.spacing.stack.small};
      gap: ${theme.spacing.inline.small};
      grid-template-columns: 1fr 2fr 1fr 1fr;
    }
  `}
`

export const CouponFormWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    height: 100%;
    width: 100%;
    background: ${theme.color.neutral.nth4};
  `}
`
